import React from 'react';
import _get from 'lodash/get';
import { FormTemplateQuestionFieldsKindEnum } from 'graphql-common';
import Checklist from '@lib/components/Checklist/Checklist';
import FormTemplateFieldNames from '@lib/enums/fieldNames/formTemplateFieldNames';
import { ComponentProps, defaultProps } from '../types';

export default function ChecklistPreview(props: ComponentProps) {
  const { options } = props;
  const limitToOneResp = _get(
    props,
    [FormTemplateFieldNames.Settings, FormTemplateFieldNames.LimitToOneResp],
    false,
  ) as boolean;
  const preparedOptions = options.map(({ values, id }) => ({
    id,
    label: values[0],
    value: values[0],
  }));
  const value = [];
  return (
    <Checklist
      {...defaultProps}
      options={preparedOptions}
      value={value}
      name={FormTemplateQuestionFieldsKindEnum.Checklist}
      limitToOneResp={limitToOneResp}
    />
  );
}
